export const MINUTE = 60 * 1000;

export const FRONT_CHAT_API_URL = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
